module.exports = __webpack_public_path__ + "static/banner-mobile-en-6110e6aa5bccbfd4602018281959ac4f.png";